import ReturnMessage from '../ReturnMessage'
import SelectInput from '../SelectInput'
import Button from '../Button'
import LoadingOverlay from '../LoadingOverlay'
import usePost from '../../hooks/usePost'
import {useContext, useEffect, useState} from 'react'
import {useLocation} from 'react-router'
import format from "date-fns/format"
import poweredByContext from '../../store/PoweredByContext'
import {Link, useNavigate} from 'react-router-dom'
import ModalFormWrapper from '../ModalFormWrapper'
import tick from '../../assets/icons/tick-big.svg'
import { closeReasonList } from '../../data/portalFormListData'
import chevronDown from '../../assets/icons/chevron-down-big-white.svg'


const PortalAvinodeCtaModal = ({closeModal, url}) => {
    // State
    const [reason, setReason] = useState('')
    

    //const authCtx = useContext(authContext)
    const poweredByCtx = useContext(poweredByContext)
    const navigate = useNavigate()

    const openAvinodeHandler = () => {
        window.open(url, '_blank', 'noreferrer')
        closeModal()
    } 

    // Use effect
    // useEffect(() => {
    //         closeModal()
        
    // }, [closeModal, reason, navigate])

    return (
        <ModalFormWrapper title='AVINODE MARKETPLACE'>
        {
            <div className='login-form'>
                <div className='login-form__body'>
                    <div className='login-form__body__title'>
                        Trip now created in Avinode
                    </div>
                    <div className='login-form__body__intro'>
                        You can select aircraft for this trip by clicking the marketplace link below
                    </div>

                    <div className='login-form__body__submit-container'>
                        <Button onClick={openAvinodeHandler} classNames={['button--full']}>MARKETPLACE</Button>
                    </div>
                </div>
            </div>
        }
        </ModalFormWrapper>
    )
}

export default PortalAvinodeCtaModal